(function () {
    'use strict';

    angular
        .module('adminTravelRoutes', [
            'travelControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider
        
            // travel Home
            .state('travel', {
                url: '/Travel/GovernanceProcess',
                abstract: true,
                resolve: {
                    govProcessType: ['travelService', function (travelService) {
                        return travelService.getProcessType();
                    }],
                    fiscalYears: ['grcGovernanceProcessService', function (service) {
                        return service.getFiscalYears();
                    }]
                },
                template: '<div ui-view="govProcess"></div>'
            })
        
            // View Active Gov Process
            .state('travel.governanceProcessActive', {
                url: '/Active',
                views: {
                    'govProcess@travel': {
                        resolve : {
                            governanceProcess: ['travelService', 'errorManagementService', function (travelService, errorManagementService) {
                                return travelService.getActiveGovernanceProcess()
                                                    .then(function (governanceProcess) {
                                                        return governanceProcess
                                                    }, function (response) {
                                                        errorManagementService.manageError(response)
                                                    })
                            }]
                        },
                        templateUrl: require('./travelGovernanceProcessList.tpl.html'),
                        controller: 'TravelGovernanceProcessListController'
                    }
                }
            })

            // Add Gov Process
            .state('travel.governanceProcessAdd', {
                url: '/Add',
                views: {
                    'govProcess@travel': {
                        resolve: {
                            governanceProcess: function () { return {}; }
                        },
                        templateUrl: require('./travelGovernanceProcessEdit.tpl.html'),
                        controller: 'TravelGovernanceProcessEditController'
                    }
                }
            })

            // Edit Gov Process
            .state('travel.governanceProcessEdit', {
                url: '/{GovernanceProcessID:int}',
                views: {
                    'govProcess@travel': {
                        resolve: {
                            governanceProcess: ['$stateParams', 'travelService', function ($stateParams, service) {
                                return service.getGovernanceProcessByID($stateParams.GovernanceProcessID);
                            }]
                        },
                        templateUrl: require('./travelGovernanceProcessEdit.tpl.html'),
                        controller: 'TravelGovernanceProcessEditController'
                    }
                }
            });
    }
})();